import {
	WeaTop,
	WeaRightMenu,
	WeaDialogFooter,
} from 'ecCom';
import {
	observer
} from 'mobx-react';
import Content from './Content';

@observer
export default class Top extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			store
		} = this.props, {
			TOP,
			top,
			pageLoading,
			topButtons,
			footerButtons,
			dropMenuDatas,
		} = store;

		if (false) { //隐藏头部
			return (
				<WeaTop ecId={`${this && this.props && this.props.ecId || ''}_WeaTop@du26yk`} 
	               {...TOP}
	               {...top}
	               loading={pageLoading}
	               buttons={topButtons}
	               dropMenuDatas={dropMenuDatas}
	            >
	            	<WeaRightMenu ecId={`${this && this.props && this.props.ecId || ''}_WeaRightMenu@2qkqv3`} datas={dropMenuDatas}>
	            		<Content ecId={`${this && this.props && this.props.ecId || ''}_Content@dfo9fp`} store={store}/>
	            	</WeaRightMenu>
	            </WeaTop>
			);
		} else {
			return (
				<WeaRightMenu ecId={`${this && this.props && this.props.ecId || ''}_WeaRightMenu@rea9zq`} datas={dropMenuDatas}>
            		<Content ecId={`${this && this.props && this.props.ecId || ''}_Content@nfhee1`} store={store}/>
            		<WeaDialogFooter ecId={`${this && this.props && this.props.ecId || ''}_WeaDialogFooter@3098j3`} buttons={footerButtons} moreBtn={{datas:[]}}/>
            	</WeaRightMenu>
			)
		}


	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/group/Top.js